import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ApiUrls } from '../../apiRouts';
import { MainService } from '../../service/main.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { CheckActiveDialogComponent } from '../check-active-dialog/check-active-dialog.component';
import { ToasterServiceService } from '../../service/toaster.service';
import { environment } from '../../../environments/environment';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-activemember',
  templateUrl: './activemember.component.html',
  styleUrl: './activemember.component.scss'
})
export class ActivememberComponent implements OnInit {
  baseUrl = environment.imageURL;
  MemberList: any = [];
  originalMemberListData: any[] = [];
  userTypeId: any;

  constructor(    
    private toasterService: ToasterServiceService,
    private dialog: MatDialog, private location: Location,
    private mainService: MainService,
    private localStorageService: LocalStorageService
  ) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
  }

  ngOnInit() {
    this.fetchMembers();
  }
  goBackToPrevPage() {
    this.location.back();
  }

  searchMember(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.MemberList = [...this.originalMemberListData];
      return;
    }
    this.MemberList = this.originalMemberListData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue)
    });
  }

  fetchMembers() {
    let data = {
      user_id: 0,
      name: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: 0,
      current_city_id: 0,
      education: "",
      dob: "",
      blood_group: "",
      image: "", // Assuming 'image' is a property of the member object
      //image_file:"",
      relation_id: 0,
      main_member_id: 0,
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: 0,
      password: "",
      created_by: 0,
      Action: 'NOTVERIFIED'
    };
    this.mainService.putApi(ApiUrls.verifiedMemberList, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.MemberList = res.user;
        this.originalMemberListData = res.user;
      }
      else {
        this.toasterService.toastError('No Data Found');
      }
    });
  }

  CheckActive(id: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'activemember'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.UpdateStatus(id);
      }
    });
  }

  UpdateStatus(member: any) {
    let data = {
      user_id: member.user_id,
      name: member.name,
      address: member.address,
      contact_no: member.contact_no,
      whatsapp_no: member.whatsapp_no,
      business: member.business,
      office_contact: member.office_contact,
      office_address: member.office_address,
      village_id: member.village_id,
      current_city_id: member.current_city_id,
      education: member.education,
      dob: member.dob,
      blood_group: member.blood_group,
      image: member.image, // Assuming 'image' is a property of the member object
      image_file: member.image_file,
      relation_id: member.relation_id,
      main_member_id: member.main_member_id,
      maternal_name: member.maternal_name,
      maternal_village_id: member.maternal_village_id,
      is_verified: member.is_verified,
      user_type_id: member.user_type_id,
      password: member.password,
      created_by: member.created_by,
      Action: 'VERIFIED'
    };
    if (member.is_verified === 0) {
      this.mainService.postApi(ApiUrls.userSignUp, data, 1).subscribe((res: any) => {
        if (res.status == 1) {
          this.toasterService.toastSuccess(res.response);
          this.fetchMembers();
        } else {
          this.toasterService.toastError(res.response);
        }
      });
    }
  }

}



